/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import ReactDOM from 'react-dom';

import { React, useEffect, useState } from 'fierry/react.old';


export const Container = React.forwardRef( ({ count }, containerRef) =>
{
  const getContainerMap = () =>
  {
    if (!containerRef.current)
    {
      containerRef.current = new Map();
    }

    return containerRef.current;
  }

  let layers = [];

  for (let i = 0; i < count; ++i)
  {
    const refCallback = (node) =>
    {
      let map = getContainerMap();

      if (node)
      {
        map.set(i, node);
      }
      else
      {
        map.delete(i);
      }
    };

    layers.push(<g key = {i} ref = {refCallback} />)
  }

  return layers;
});


export const Placement = ({ containerRef, index, children }) =>
{
  const [ isReady, setIsReady ] = useState(false);

  useEffect(() =>
  {
    if (containerRef.current)
    {
      setIsReady(true);
    }
  }, []);

  return isReady ? ReactDOM.createPortal(children, containerRef.current.get(index)) : null;
}
